import GroupIcon from '@mui/icons-material/VerifiedUser';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import RowMenuItem from '../../DataGrid/RowMenuItem';
import messages from './messages';

function SetApartmentGroup({ onClick }) {
  const { formatMessage } = useIntl();
  return (
    <RowMenuItem
      icon={<GroupIcon />}
      label={formatMessage(messages.apartmentRowMenuAddApartmentGroup)}
      onClick={onClick}
    />
  );
}

SetApartmentGroup.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default SetApartmentGroup;
